import React, { useState, useEffect, useRef } from 'react';
import axios from '../Axiosinstance';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBook,
  faCalendar,
  faGraduationCap,
  faCog,
  faQuestionCircle,
  faFolder,
  faUser,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { Badge } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import { Modal, Button } from 'react-bootstrap';
import { buttonBackgroundColor, logoImage } from '../common';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from "react-router-dom";


function App() {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isHelpOpen, setHelpOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);

  const [hover, setHover] = useState(false);

  const resourcesRef = useRef(null);
  const helpRef = useRef(null);
  const accountRef = useRef(null);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1200);
    };
  
    checkScreenSize(); // Run on mount
    window.addEventListener("resize", checkScreenSize);
  
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  


  const openModal = () => {
    setShowModal(true);
  };


  const openNotificationsModal = () => {
    axios.get('admin-notifications/unseen')
      .then(response => {
        if (response.status === 200) {
          setNotifications(response.data);
          setShowNotificationsModal(true);
        }
      })
      .catch(error => {
        console.error('Error fetching notifications:', error);
      });
  };

  const closeNotificationsModal = () => {
    setShowNotificationsModal(false);
  };

  const toggleResources = (e) => {
    setResourcesOpen(!isResourcesOpen);
    setHelpOpen(false);
    setAccountOpen(false);
  };

  const toggleHelp = () => {
    setHelpOpen(!isHelpOpen);
    setResourcesOpen(false);
    setAccountOpen(false);
  };

  const toggleAccount = () => {
    setAccountOpen(!isAccountOpen);
    setResourcesOpen(false);
    setHelpOpen(false);
  };

  const [isHamburgerActive, setHamburgerActive] = useState(false);
  const [isNavActive, setNavActive] = useState(false);
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    document.title = "LMS-impluz";
    openModal();
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data;
            localStorage.setItem("studentteacherid", data.sfid);
            document.title = `impluz - ${data.name}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url);
          } else {
            throw new Error("Failed to fetch sfid");
          }
        })
        .catch((error) => {
          console.error(error.response);
          if (error == "AxiosError: Network Error")
            handleLogout();
        });
    }
  }, []);

  const toggleHamburger = () => {
    setHamburgerActive((prevState) => !prevState);
    setNavActive((prevState) => !prevState);
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
        setResourcesOpen(false);
      }
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setHelpOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fetch notification count
  useEffect(() => {
    const fetchNotificationCount = () => {
      axios.get('admin-notifications/unseen-count')
        .then(response => {
          if (response.status === 200) {
            setNotificationCount(response.data); // Assuming response.data.count contains the count
          }
        })
        .catch(error => {
          console.error('Error fetching notification count:', error);
        });
    };

    // Fetch notifications every 5 minutes
    fetchNotificationCount();
    const intervalId = setInterval(fetchNotificationCount, 300000); // 300000 ms = 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  const markNotificationAsSeen = (id) => {
    axios.post(`admin-notifications/${id}/seen`)
      .then(() => {
        // Re-fetch the notifications after marking one as seen
        openNotificationsModal();
        // Optionally, update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking notification as seen:', error);
      });
  };

  const markAllNotificationsAsSeen = () => {
    axios.post('admin-notifications/mark-all-seen')
      .then(() => {
        // Re-fetch the notifications after marking all as seen
        openNotificationsModal();
        // Update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking all notifications as seen:', error);
      });
  };


  const itemStyle = {
    transition: 'background-color 0.3s',
    cursor: 'pointer',
    backgroundColor: hover ? '#f0f0f0' : 'transparent', // Change background color on hover
    color: hover ? '#FFC300' : 'inherit', // Change text/icon color on hover
    borderRadius: hover ? '30%' : '0', // Add border-radius on hover
    padding: '20px', // Optional: to ensure some space around the content
  };

  // const navigate = useNavigate(); 
  const handleBack = () => {
    navigate(-1);  // Goes back to the previous page in history
  };

  return (
    <div className={` ${isNavOpen ? 'opened' : ''}`}>
      <nav>
        <div className="logo">
          <Link to='/adhome'>
            <img id='imglogo' src={logoImage} alt="logoImage" />
          </Link>
        </div>
        <button className={`btn-hamburger ${isNavOpen ? 'opened' : ''}`} onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`} >
          <li className="nav-item"> <Link to="/adhome"><FontAwesomeIcon icon={faHome} /> Home </Link></li>
          <li className="nav-item"><Link to="/Batches"> <FontAwesomeIcon icon={faBook} /> Batches </Link></li>
          {/* <li className="nav-item"><Link to="/Batch"><FontAwesomeIcon icon={faCalendar} /> Roaster </Link></li> */}
          {/* <li className="nav-item"><Link to="/Sswcommon"><FontAwesomeIcon icon={faGraduationCap} /> SSG_WSQ</Link></li> */}

          <li style={{ color: 'black' }} className={`nav-item dropdown ${isResourcesOpen ? 'show' : ''}`} ref={resourcesRef}>
            <a to={''} onClick={toggleResources}> <FontAwesomeIcon icon={faFolder} />  Resources <FontAwesomeIcon />  </a>
            {isResourcesOpen ? <div className={`dropdown-menu ${isResourcesOpen ? 'show' : ''}`}>
              {/* <Link className="dropdown-item" to='/CourseCatagories'>  <FontAwesomeIcon icon={faFolder} />  Course Categories</Link> */}
              {localStorage.getItem("usertype") !== "3" && (
                <Link className="dropdown-item" to='/AllCourse'>
                  <FontAwesomeIcon icon={faBook} /> Course
                </Link>
              )}
              <Link className="dropdown-item" to='/Allstudent' >  <FontAwesomeIcon icon={faUser} />  Student</Link>
              {/* <Link className="dropdown-item" to={'/Allcourse'}>       <FontAwesomeIcon icon={faUser} /> Facilitators</Link> */}
              <Link className="dropdown-item" to='/Facilitor' > <FontAwesomeIcon icon={faUser} />  Facilitators</Link>

              <Link className="dropdown-item" to='/All' ><FontAwesomeIcon icon={faBook} />  Venues</Link>
              <Link className="dropdown-item" to='/StudentReport' ><FontAwesomeIcon icon={faBook} />  Student Report</Link>
              <Link className="dropdown-item" to='/Feedbacks' ><FontAwesomeIcon icon={faBook} />  Feedback</Link>
              {/* <Link className="dropdown-item" to='/certificate' ><FontAwesomeIcon icon={faBook} />  Certificate</Link> */}

              {/* <Link className="dropdown-item" to='/Allas'><FontAwesomeIcon icon={faBook} />  Assessment Setup</Link> */}

              {/* <Link className="dropdown-item" to='/Studentrecords'><FontAwesomeIcon icon={faBook} />  Students Records</Link> */}

              {/* <a className="dropdown-item" href='/Allas' ><FontAwesomeIcon icon={faBook} />  Assessment Setup</a> */}

              {/* <a className="dropdown-item" href='/Acadamic' ><FontAwesomeIcon icon={faBook} />  General Report</a> */}
              {/* <Link className="dropdown-item" to={'/Payment'}>  <FontAwesomeIcon icon={faBook} /> Payments</Link> */}
            </div> : null}
          </li>

          {localStorage.getItem("usertype") !== "3" && (
            <li className="nav-item">
              <Link to='/Setting' >  <FontAwesomeIcon icon={faCog} /> Settings</Link></li>)}


          <li style={{ color: 'black' }} className={`nav-item dropdown ${isHelpOpen ? 'show' : ''}`} ref={helpRef}>

            <Link to='' onClick={toggleHelp}><FontAwesomeIcon icon={faQuestionCircle} /> Help <FontAwesomeIcon /></Link>

            <div className={`dropdown-menu ${isHelpOpen ? 'show' : ''}`}>

              <Link className="dropdown-item" to='/Chat'>Contact us</Link>

              {/* <Link className="dropdown-item" to=''>Live Chat</Link>

  <Link className="dropdown-item" to=''>Remote Desktop</Link> */}

            </div>

          </li>



          <li
            className="nav-item"
            style={itemStyle}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <Badge
              badgeContent={notificationCount}
              onClick={openNotificationsModal}
              color="error"
            // style={{ display: 'flex', alignItems: 'center' }} // Ensure badge and icon are centered
            >
              <NotificationsIcon />
              <span style={{ fontSize: '18px'  }}>Notification</span>
            </Badge>
            {/* <h6 style={{ margin: '0', fontSize: '16px', color: '#000' }}>Notification</h6> */}
          </li>





          <span style={{ width: '40px' }}>
            <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
              <Link to='' onClick={toggleAccount}>
                {profileUrl ? (
                  <img
                    src={profileUrl}
                    alt="Profile"
                    style={{ marginLeft: '5px', borderRadius: '50%', width: '50px', height: '50px' }}
                  />
                ) : (
                  <span
                    style={{
                      marginLeft: '5px',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      backgroundColor: 'gray',
                    }}
                  ></span>
                )}
                {studentName ? (
                  // Display only the first word of the student's name
                  studentName.split(' ')[0]
                ) : (
                  <span className="placeholder-text">Loading</span>
                )}
                <FontAwesomeIcon />
              </Link>

              <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`} ref={accountRef}>
                <Link className="dropdown-item" to="/Profile">Profile</Link>
                <Link onClick={handleLogout} className="dropdown-item" to='/'>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Log out
                </Link>
              </div>
            </li>
          </span>

        </ul>
      </nav>
      <br/>
      <br/>
      <br/>
      <br/>
      {/* <div className="container">

      </div> */}

      <Modal show={showNotificationsModal} onHide={closeNotificationsModal} fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>Notifications</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {notifications.length === 0 ? (
            <p>No new notifications</p>
          ) : (
            <ul>
              {/* <h2>New students Were Added</h2> */}
              {notifications.map((notification) => (
                <li key={notification.id} className="notification-item">
                  <div className="notification-header">
                    <h3 className="notification-title">{notification.name}</h3>
                    <button
                      className="mark-seen-button"
                      onClick={() => markNotificationAsSeen(notification.id)}
                    >
                      Mark as Seen
                    </button>
                  </div>
                  <p className="notification-email">{notification.email}</p>
                  <p className="notification-phone">{notification.phoneNumber}</p>
                  {/* <p className="notification-message">{notification.message}</p> */}
                  <p className="notification-amount">Paid amount :{notification.amount}</p>
                  <p className="notification-amount">Intake Id  :{notification.intakeId}</p>
                </li>
              ))}
            </ul>
          )}

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{ backgroundColor:buttonBackgroundColor }} onClick={closeNotificationsModal}>
            Close
          </Button>
          <Button style={{ width: "49px",backgroundColor:buttonBackgroundColor }} variant="primary" onClick={markAllNotificationsAsSeen}>
            Mark All as Seen
          </Button>
        </Modal.Footer>
      </Modal>
      {!isMobile && location.pathname.toLowerCase() !== "/adhome" && (
  <Button
  style={{backgroundColor:'#1565C0'}}
    sx={{
      // backgroundColor: '#000000',
      color: 'white',
      borderRadius: '10px',
      padding: '8px 16px',
      minWidth: '80px',
      fontSize: { xs: '12px', sm: '14px', md: '16px' },
      '&:hover': { backgroundColor: '#0056b3' }
    }}
    onClick={handleBack}
  >
    <ArrowBackIcon />
  </Button>
)}



    </div>
  );
}

export default App;
